import * as api from '../api';
import * as hygge from '../hygge';

export class HyggeFilterService {
    public comfort: hygge.HyggeFilter;
    public entertainment: hygge.HyggeFilter;
    public kids: hygge.HyggeFilter;
    public food: hygge.HyggeFilter;
    public features: hygge.HyggeFilter;

    constructor(hyggies: { [id: string]: api.HyggeModel[] }) {
        this.comfort = new hygge.HyggeFilter(hyggies.comfort);
        this.entertainment = new hygge.HyggeFilter(hyggies.entertainment);
        this.kids = new hygge.HyggeFilter(hyggies.kids);
        this.food = new hygge.HyggeFilter(hyggies.food);
        this.features = new hygge.HyggeFilter(hyggies.features);
    }

    get touched(): boolean {
        return this.comfort.touched
            || this.entertainment.touched
            || this.kids.touched
            || this.food.touched
            || this.features.touched;
    }

    public filter(
        hyggies: hygge.HyggeFilterModel[],
        hyggiesToView: { [id: string]: api.HyggeDetailsModel }
    ): number {
        // Filter
        this.filterItems(hyggies, hyggiesToView);

        // Sort
        this.sortItems(hyggies, hyggiesToView);

        // Count results
        let result = 0;

        hyggies.forEach((f) => {
            if (f.visible) {
                result++;
            }
        });

        return result;
    }

    clear() {
        this.comfort.clear();
        this.entertainment.clear();
        this.kids.clear();
        this.food.clear();
        this.features.clear();
    }

    private filterItems(hyggies: hygge.HyggeFilterModel[], hyggiesToView: { [id: string]: api.HyggeDetailsModel }) {
        hyggies.forEach((h) => {
            const hygge = hyggiesToView[h.id];

            if (!this.touched
                || (this.touched
                    && (this.comfort.check(hygge)
                        || this.entertainment.check(hygge)
                        || this.kids.check(hygge)
                        || this.food.check(hygge)
                        || this.features.check(hygge)))) {
                h.visible = true;

                return;
            }

            h.visible = false;
        });
    }

    private sortItems(hyggies: hygge.HyggeFilterModel[], hyggiesToView: { [id: string]: api.HyggeDetailsModel }) {
        hyggies.sort((a, b) => {
            return hyggiesToView[a.id].id == hyggiesToView[b.id].id ? 0 : (hyggiesToView[a.id].id > hyggiesToView[b.id].id ? -1 : 1);
            //return hyggiesToView[a.id].airlineName == hyggiesToView[b.id].airlineName ? 0 : (hyggiesToView[a.id].airlineName > hyggiesToView[b.id].airlineName ? 1 : -1);
        });
    }
}
